import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { TextField } from '@redshelf/redshelf-ui';
import IconButton from 'components/IconButton';

const useStyles = makeStyles(
  (theme) => {
    return {
      endAdornment: {
        padding: theme.spacing(1.25),
        color: theme.palette.greyBlue[600],
      },
      search: {
        display: 'flex',
        padding: theme.spacing(3, 2),
      },
      searchInput: {
        margin: 0,
        borderRight: 'none',
        height: theme.spacing(5.5),
        width: '100%',
        '&.MuiTextField-root .MuiInputBase-root': {
          height: theme.spacing(5.5),
        },
        '&.MuiTextField-root': {
          width: '-webkit-fill-available',
        },
      },
      searchButton: {
        width: theme.spacing(5.5),
        height: theme.spacing(5.5),
        left: '-3px',
        borderRadius: '0px 4px 4px 0px',
        backgroundColor: theme.palette.shelfBlue['500'],
        color: '#fff',
        '&:hover': {
          backgroundColor: theme.palette.shelfBlue['500'],
        },
      },
    };
  },
  { name: 'MuiSearchBar' },
);

const SearchBar = React.forwardRef(function SearchBar(
  { onChange, onSubmit, value, ...props },
  ref,
) {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event) => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);
    event.stopPropagation();
    event.preventDefault();

    await onSubmit(event);
    setIsLoading(false);
  };

  return (
    <form
      aria-label="Search for a term or phrase in the book content"
      className={classes.search}
      onSubmit={handleSubmit}
      role="search"
    >
      <TextField
        aria-controls="search-results-summary"
        aria-label="Search"
        className={classes.searchInput}
        InputProps={{
          endAdornment: isLoading && (
            <InputAdornment position="end">
              <CircularProgress className={classes.endAdornment} />
            </InputAdornment>
          ),
          inputRef: ref,
        }}
        name="search"
        onChange={onChange}
        placeholder="Search"
        value={value}
        {...props}
      />
      <IconButton
        aria-label="Submit Search"
        className={classes.searchButton}
        type="submit"
      >
        <Search />
      </IconButton>
    </form>
  );
});

SearchBar.muiName = 'SearchBar';

SearchBar.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default SearchBar;
